import { gql } from "@apollo/client";

//queries

export const QUERY_STAY_TIME_REPORT = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedLockerName: [Int]
    $selectedRadio: String
  ) {
    lockerStayTimeByHours(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerIds: $selectedLockerName
      period: $selectedRadio
    ) {
      hours
      lockers
      packages
      periods {
        name
        packages
      }
    }
  }
`;

export const QUERY_LOCKER_TYPE = gql`
  query {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const QUERY_LOCKER_NAME = gql`
  query ($operatorId: ID!, $selectedLockerType: Int) {
    lockers(operatorId: $operatorId, lockerTypeId: $selectedLockerType) {
      lockerName
      lockerId
    }
  }
`;

export const NEWEST_LOCKER_NAME_QUERY = gql`
  query ($operatorId: ID!, $lockerTypeId: ID) {
    lockerInfo(operatorId: $operatorId, lockerTypeId: $lockerTypeId) {
      lockerName
      lockerId
      lockerType
      lockerTypeId
      __typename
    }
  }
`;

export const LOCKER_INFO_QUERY = gql`
  query ($operatorId: ID!) {
    lockerInfo(operatorId: $operatorId) {
      lockerId
      lockerName
      lockerType
      lockerTypeId
    }
  }
`;
